<template>
    <div class="radio-group">

        <div :class="['radio-option',
                     {'active': isOptionActive(option),
                      'is-first': index === 0,
                      'is-last':  index === options.length - 1}]"
             v-for="(option, index) in options"
             :key="option.id"
             @click="setActiveOption(option)"
        >
            <div>
                <span>
                    {{ option }}
                </span>
            </div>
        </div>

    </div>
</template>

<script>
    export default {
        name: "RadioGroup",
        props: {
            value: {
                type: String,
                default: ''
            },
            options: {
                type: Array,
                default: () => {
                    return []
                }
            }
        },
        data() {
            return {
                currentElement: ''
            }
        },
        methods: {
            isOptionActive(option) {
                return option === this.currentElement
            },
            setActiveOption(option) {
                this.currentElement = option
            }
        },
        mounted() {
            this.currentElement = this.value
        },
        watch: {
            currentElement(value) {
                this.$emit('input', value)
            }
        }
    }
</script>